var map = {
	"./flag_br.png": 1044,
	"./flag_de.png": 1045,
	"./flag_es.png": 1046,
	"./flag_fr.png": 1047,
	"./flag_id.png": 1048,
	"./flag_in.png": 1049,
	"./flag_it.png": 1050,
	"./flag_my.png": 1051,
	"./flag_ph.png": 1052,
	"./flag_ru.png": 1053,
	"./flag_th.png": 1054,
	"./flag_tr.png": 1055,
	"./flag_uz.png": 1056,
	"./flag_СНГ.png": 1014
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1003;